export default function SocialCodepenOutline() {
  return (
    <div
      className="ion-icon-social-codepen-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path fill-rule="evenodd" clip-rule="evenodd" d="M387.547,203.724c-41.135-27.326-82.225-54.721-123.261-82.195
		c-5.844-3.912-11.12-3.802-16.938,0.095c-40.785,27.313-81.818,54.546-122.724,81.676c-5.103,3.384-7.624,7.575-7.624,13.716
		v79.729c0,6.174,2.484,10.342,7.594,13.73c40.906,27.13,81.841,54.361,122.625,81.676c5.81,3.891,11.131,4.055,16.984,0.137
		c41.035-27.474,82.145-54.873,123.286-82.188c4.858-3.226,7.511-7.309,7.511-13.094v-80.623
		C395,210.667,392.225,206.83,387.547,203.724z M268,152.484l93.055,62.218l-39.751,26.467c-0.919,0.603-2.923,0.604-3.839,0
		c-15.944-10.501-31.816-21.113-47.627-31.815c-1.033-0.699-1.828-2.319-1.838-3.52V152.484z M244,152.765v51.706
		c-0.024,1.825-1.313,4.316-2.799,5.334c-15.258,10.451-30.655,20.701-46.109,30.86c-1.17,0.77-3.547,1.148-4.566,0.485
		c-13.116-8.531-26.087-17.284-39.787-26.443C181.967,193.889,244,152.765,244,152.765z M141,237.116l29.622,19.771L141,276.725
		V237.116z M244,361.317c0,0-62.034-41.412-93.196-62.187l38.871-26.154c2.072-1.442,3.473-1.344,5.502,0.029
		c15.32,10.36,30.74,20.572,46.062,30.93c1.208,0.815,2.749,2.371,2.761,3.596V361.317z M258.949,282.892
		c-1.824,1.108-4.512,1.046-6.26-0.111l-38.842-25.865c0,0,17.108-11.493,25.356-17.023c4.701-3.152,9.346-6.393,14.164-9.355
		c1.132-0.696,3.532-0.97,4.743-0.168c5.773,3.829,39.854,26.53,39.854,26.53L258.949,282.892z M268,361.102v-51.346
		c-0.026-2.871,0.449-4.602,2.861-6.189c15.198-10.006,30.332-20.11,45.386-30.332c2.335-1.586,3.92-1.623,6.265-0.019
		l38.527,25.882L268,361.102z M370,276.676l-29.59-19.743L370,237.06V276.676z"/>
	<path d="M256,64c51.285,0,99.5,19.972,135.765,56.235C428.028,156.5,448,204.715,448,256s-19.972,99.5-56.235,135.765
		C355.5,428.028,307.285,448,256,448s-99.5-19.972-135.765-56.235C83.972,355.5,64,307.285,64,256s19.972-99.5,56.235-135.765
		C156.5,83.972,204.715,64,256,64 M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32
		L256,32z"/>
</g>
</svg>
`,
      }}
    />
  )
}
